module.exports = __webpack_public_path__ + "img/petstairs47.75eef19b.jpg";